import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from 'antd';
import {
  CREATE_USER_PANCARD_VERIFY,
  MOBILE_SEND_VERFIY,
  MOBILE_VERFIY_SEND,
  CREATE_USERS_STAFF,
  DIGILOCKER_VERIFY,
  CREATE_DIGILOCKER_URL,
  GET_VERIFICATION_STATUS,
  GET_DOCUMENT_DATA,
} from './../../Utils/appConstants';
import { postRequest } from './../../Utils/AppApi';
import { getUser, isNumber } from "./../../Utils/Common";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import RiseLoader from 'react-spinners/RiseLoader';
import { UserOutlined, MobileOutlined, IdcardOutlined, LockOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const userData = getUser();

function CreateStaff(props) {
    const mobileNumberRef = useRef(null);
    const otpNumberRef = useRef(null);
    const pancardNumberRef = useRef(null);

    const history = useHistory();
    
    const [isData, setData] = useState({
        mobileNumber: '',
        OtpNumber: '',
        pancardNumber: '',
        firstName: '',
        lastName: ''
    });
    
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        pancardNumber: '',
        mobileNumber: '',
        OtpNumber: ''
    });
    
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [pancardData, setPancardData] = useState(null); // Initialize as null
    const [isOtpNumber, setOtpNumber] = useState(false);
    const [roleId, setRoleId] = useState(userData?.data?.role?.code);
    const [isMobileNumberVerify, setMobileNumberVerify] = useState(false);
    const [isPanNumberVerify, setPanNumberVerify] = useState(false);
    const [showingSubmitPopup, setShowingSubmitPopup] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [pancardNumber, setPancardNumber] = useState('');
    const [touched, setTouched] = useState({
        firstName: false,
        lastName: false,
        pancardNumber: false,
        mobileNumber: false,
        OtpNumber: false
    });

    // DigiLocker states
    const [verificationId, setVerificationId] = useState(null);
    const [referenceId, setReferenceId] = useState(null);
    const verificationIdRef = useRef(null);
    const referenceIdRef = useRef(null);
    const isSubmittingRef = useRef(false);
    const hasAutoSubmittedRef = useRef(false);

    const clearFormField = () => {
        setData({
            mobileNumber: '',
            OtpNumber: '',
            pancardNumber: '',
            firstName: '',
            lastName: ''
        });
        setErrors({
            firstName: '',
            lastName: '',
            pancardNumber: '',
            mobileNumber: '',
            OtpNumber: ''
        });
        setTouched({
            firstName: false,
            lastName: false,
            pancardNumber: false,
            mobileNumber: false,
            OtpNumber: false
        });
        setFirstName('');
        setLastName('');
        setPancardData(null); // Set to null
        setPancardNumber('');
        setOtpNumber(false);
        setMobileNumberVerify(false);
        setPanNumberVerify(false);
        setVerificationId(null);
        setReferenceId(null);
        verificationIdRef.current = null;
        referenceIdRef.current = null;
        isSubmittingRef.current = false;
        hasAutoSubmittedRef.current = false;
        
        if (mobileNumberRef.current) mobileNumberRef.current.value = '';
        if (otpNumberRef.current) otpNumberRef.current.value = '';
        if (pancardNumberRef.current) pancardNumberRef.current.value = '';
    };

    const validateField = (name, value) => {
        let error = '';
        
        switch(name) {
            case 'firstName':
                if (!value || value.trim() === '') {
                    error = 'First name is required';
                } else if (value.length < 2) {
                    error = 'First name must be at least 2 characters';
                }
                break;
            case 'lastName':
                if (!value || value.trim() === '') {
                    error = 'Last name is required';
                } else if (value.length < 2) {
                    error = 'Last name must be at least 2 characters';
                }
                break;
            case 'pancardNumber':
                if (!value || value.trim() === '') {
                    error = 'PAN card number is required';
                } else {
                    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                    if (!panRegex.test(value.trim().toUpperCase())) {
                        error = 'Enter a valid PAN number (e.g., ABCDE1234F)';
                    }
                }
                break;
            case 'mobileNumber':
                if (!value || value.trim() === '') {
                    error = 'Mobile number is required';
                } else if (!/^\d{10}$/.test(value)) {
                    error = 'Enter a valid 10-digit mobile number';
                }
                break;
            case 'OtpNumber':
                if (!value || value.trim() === '') {
                    error = 'OTP is required';
                } else if (!/^\d{4}$/.test(value)) {
                    error = 'Enter a valid 4-digit OTP';
                }
                break;
            default:
                break;
        }
        
        return error;
    };

    const handleBlur = (fieldName, value) => {
        setTouched({ ...touched, [fieldName]: true });
        const error = validateField(fieldName, value);
        setErrors({ ...errors, [fieldName]: error });
    };

    const validateForm = () => {
        const newErrors = {
            firstName: validateField('firstName', isData.firstName),
            lastName: validateField('lastName', isData.lastName),
            pancardNumber: validateField('pancardNumber', isData.pancardNumber),
            mobileNumber: validateField('mobileNumber', isData.mobileNumber)
        };
        
        setErrors(newErrors);
        setTouched({
            firstName: true,
            lastName: true,
            pancardNumber: true,
            mobileNumber: true,
            OtpNumber: true
        });
        
        return !Object.values(newErrors).some(error => error !== '');
    };

    const handleSubmitAPI = async () => {
        if (isSubmittingRef.current || hasAutoSubmittedRef.current) {
            console.log('Submission already in progress or completed');
            return;
        }
        
        isSubmittingRef.current = true;
        hasAutoSubmittedRef.current = true;
        
        // Ensure pancardData is an object
        let finalPancardData = {};
        
        if (pancardData && typeof pancardData === 'object') {
            finalPancardData = pancardData;
        } else if (pancardData && typeof pancardData === 'string') {
            try {
                finalPancardData = JSON.parse(pancardData);
            } catch (e) {
                console.error('Error parsing pancardData:', e);
                finalPancardData = {};
            }
        }
        
        const payload = {
            pancard: pancardNumber || '',
            firstName: firstName || '',
            lastName: lastName || '',
            mobile: isData.mobileNumber || '',
            roleCode: roleId || '',
            pancardData: finalPancardData // This will be an object, not empty string
        };
        
        console.log('Submitting staff data payload:', JSON.stringify(payload, null, 2));
        
        try {
            const response = await postRequest(CREATE_USERS_STAFF, payload, history);
            console.log('Submit response:', response);
            
            if (response && response.success) {
                setShowingSubmitPopup(true);
                setUsername(response.data?.username || '');
                setPassword(response.data?.password || '');
                toast.success(response.message || 'Staff created successfully!');
                setTimeout(() => {
                    clearFormField();
                }, 2000);
            } else {
                toast.error(response?.message || 'Staff creation failed');
                isSubmittingRef.current = false;
                hasAutoSubmittedRef.current = false;
            }
        } catch (error) {
            console.error('Staff creation error:', error);
            toast.error('Staff creation failed. Please try again.');
            isSubmittingRef.current = false;
            hasAutoSubmittedRef.current = false;
        } finally {
            setLoading(false);
        }
    };

    const initiateDigilocker = (mobileNumber) => {
        if (!mobileNumber || !/^\d{10}$/.test(mobileNumber)) {
            toast.error('Please provide a valid 10-digit mobile number');
            setLoading(false);
            return;
        }

        const payload = {
            mobile: mobileNumber,
            type: 'onboarding',
        };

        console.log('Initiating DigiLocker with mobile:', mobileNumber);

        postRequest(DIGILOCKER_VERIFY, payload, history)
            .then((response) => {
                console.log('DigiLocker Response:', response);
                if (response.success === true) {
                    const verification_id = response.data?.verification_id;
                    if (verification_id) {
                        createDigilockerURL(verification_id);
                    } else {
                        toast.error('Missing verification id from DigiLocker response');
                        setLoading(false);
                    }
                } else {
                    toast.error(response.message || 'Failed to initiate DigiLocker');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('DigiLocker Error:', error);
                toast.error('Failed to initiate DigiLocker verification');
                setLoading(false);
            });
    };

    const createDigilockerURL = (verification_id) => {
        const payload = {
            verification_id,
            type: 'onboarding',
        };

        console.log('Creating DigiLocker URL with verification_id:', verification_id);

        postRequest(CREATE_DIGILOCKER_URL, payload, history)
            .then((response) => {
                console.log('DigiLocker URL Response:', response);
                if (response.success === true && response.data) {
                    setVerificationId(response.data.verification_id);
                    setReferenceId(response.data.reference_id);
                    verificationIdRef.current = response.data.verification_id;
                    referenceIdRef.current = response.data.reference_id;

                    if (response.data.url) {
                        window.open(response.data.url, '_blank', 'noopener,noreferrer');
                    }
                } else {
                    toast.error(response.message || 'Failed to create DigiLocker URL');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error('DigiLocker Error:', error);
                toast.error('Failed to initiate DigiLocker verification');
                setLoading(false);
            });
    };

    const getDocumentData = async (vid, refId, documentType) => {
        if (!vid) return;

        try {
            const payload = {
                verificationId: vid,
                referenceId: refId,
                documentType: documentType,
            };

            console.log(`Getting ${documentType} data...`);

            const res = await postRequest(GET_DOCUMENT_DATA, payload, history);
            console.log('Document Data Response:', res);
            
            if (res && res.success) {
                if (documentType === 'PAN') {
                    if (res.data && res.data.pan) {
                        const enteredPAN = pancardNumber;
                        const serverPAN = res?.data?.pan?.trim().toUpperCase() || '';

                        if (serverPAN && enteredPAN !== serverPAN) {
                            toast.error('PAN number does not match the provided record');
                            clearFormField();
                            setLoading(false);
                            return;
                        }

                        // Store the complete pancardData as an object
                        const pancardDataObject = {
                            pan: res.data.pan || '',
                            name_pan_card: res.data.name_pan_card || res.data.name || '',
                            aadhaar_seeding_status: res.data.aadhaar_seeding_status || '',
                            registered_name: res.data.registered_name || res.data.name || '',
                            ...res.data
                        };
                        
                        console.log('Setting pancardData object:', pancardDataObject);
                        setPancardData(pancardDataObject);
                        setPanNumberVerify(true);

                        const name = res.data?.name_pan_card || res.data?.name || '';
                        if (name) {
                            const parts = name.trim().split(/\s+/).filter(Boolean);
                            if (parts.length > 0 && !firstName) {
                                setFirstName(parts[0] || '');
                            }
                            if (parts.length > 1 && !lastName) {
                                setLastName(parts.slice(1).join(' ') || '');
                            }
                        }

                        verificationIdRef.current = null;
                        referenceIdRef.current = null;
                        setVerificationId(null);
                        setReferenceId(null);

                        toast.success('PAN verified successfully! Creating employee account...');
                        
                        // Wait to ensure state updates are complete
                        setTimeout(() => {
                            console.log('Calling auto-submit with pancardData:', pancardDataObject);
                            handleSubmitAPI();
                        }, 1000);
                    } else {
                        toast.error('PAN data not found in DigiLocker response');
                        setLoading(false);
                    }
                }
            } else {
                toast.error(res?.message || 'Document verification failed');
                setLoading(false);
            }
        } catch (err) {
            console.error('Error checking DigiLocker docs:', err);
            toast.error('Error verifying documents');
            setLoading(false);
        }
    };

    const handleVerifyMobileNumber = () => {
        if (!validateForm()) {
            toast.error('Please fix the errors before proceeding');
            return;
        }

        setLoading(true);

        const payload = {
            mobile: isData.mobileNumber,
            roleId: roleId,
            pancard: isData.pancardNumber.trim().toUpperCase(),
            firstName: isData.firstName.trim(),
            lastName: isData.lastName.trim()
        };

        postRequest(MOBILE_VERFIY_SEND, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    setOtpNumber(true);
                    setFirstName(isData.firstName.trim());
                    setLastName(isData.lastName.trim());
                    setPancardNumber(isData.pancardNumber.trim().toUpperCase());
                    setLoading(false);
                } else {
                    toast.error(response.message || 'Failed to send OTP');
                    setLoading(false);
                }
            })
            .catch(() => {
                toast.error('Failed to send OTP');
                setLoading(false);
            });
    };

    const handleVerifyOtpMobileNumber = () => {
        const otpError = validateField('OtpNumber', isData.OtpNumber);
        if (otpError) {
            setErrors({ ...errors, OtpNumber: otpError });
            setTouched({ ...touched, OtpNumber: true });
            toast.error(otpError);
            return;
        }

        if (!pancardNumber) {
            toast.error('PAN number is required for verification');
            return;
        }

        setLoading(true);
        const payload = {
            mobile: isData.mobileNumber,
            otp: isData.OtpNumber,
        };

        postRequest(MOBILE_SEND_VERFIY, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    setOtpNumber(false);
                    setMobileNumberVerify(true);
                    hasAutoSubmittedRef.current = false;
                    isSubmittingRef.current = false;
                    initiateDigilocker(isData.mobileNumber);
                } else {
                    toast.error(response.message || 'OTP verification failed');
                    setLoading(false);
                }
            })
            .catch(() => {
                toast.error('OTP verification failed');
                setLoading(false);
            });
    };

    const handleCancelPopup = () => {
        setShowingSubmitPopup(false);
        setUsername("");
        setPassword("");
        clearFormField();
    };

    const onChangeValue = (event) => {
        const { name, value } = event.target;
        let newValue = value;
        
        if (name === "pancardNumber") {
            newValue = value.toUpperCase();
            setData({ ...isData, [name]: newValue });
        } else if (name === "mobileNumber") {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
                newValue = digitsOnly;
                setData({ ...isData, [name]: digitsOnly });
            } else {
                return;
            }
        } else if (name === "OtpNumber") {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 4) {
                newValue = digitsOnly;
                setData({ ...isData, [name]: digitsOnly });
            } else {
                return;
            }
        } else {
            setData({ ...isData, [name]: value });
        }
        
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };

    useEffect(() => {
        verificationIdRef.current = verificationId;
    }, [verificationId]);

    useEffect(() => {
        const handleFocus = async () => {
            const vid = verificationIdRef.current;
            const refId = referenceIdRef.current;

            if (!vid || hasAutoSubmittedRef.current) {
                return;
            }

            console.log('Window focus detected, checking DigiLocker status');

            try {
                const payload = {
                    verificationId: vid,
                    referenceId: refId,
                };

                const res = await postRequest(GET_VERIFICATION_STATUS, payload, history);
                console.log('DigiLocker Status Response:', res);

                if (res && res.success) {
                    await getDocumentData(vid, refId, 'PAN');
                } else {
                    toast.error(res?.message || 'Document verification failed');
                    setLoading(false);
                }
            } catch (err) {
                console.error('Error checking DigiLocker docs:', err);
                toast.error('Error verifying documents');
                setLoading(false);
            }
        };

        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, [history, pancardNumber]);

    useEffect(() => {
        setRoleId(userData?.data?.role?.code);
    }, []);

    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: '250px 0' }}>
                <RiseLoader color="#C9262C" loading={isLoading} size={25} />
            </div>
        );
    }

    // Styles object (keeping it concise)
    const styles = {
        pageWrapper: { background: '#ffffff', minHeight: '100vh', padding: '60px 0' },
        container: { maxWidth: '1000px', margin: '0 auto', padding: '0 24px' },
        card: { background: 'white', borderRadius: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.1)', overflow: 'hidden', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', border: '1px solid #FFDD09' },
        leftPanel: { flex: '1', background: 'linear-gradient(135deg, #C9262C 0%, #FFDD09 100%)', padding: '48px 32px', color: 'white', minWidth: '260px' },
        rightPanel: { flex: '1.4', padding: '48px 40px', minWidth: '320px', background: 'white' },
        welcomeTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '12px' },
        welcomeText: { fontSize: '14px', opacity: '0.9', marginBottom: '40px', lineHeight: '1.6' },
        feature: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' },
        featureIcon: { width: '36px', height: '36px', background: 'rgba(255,255,255,0.2)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' },
        formTitle: { fontSize: '24px', fontWeight: '600', marginBottom: '8px', color: '#C9262C' },
        formSubtitle: { fontSize: '14px', color: '#6b7280', marginBottom: '32px', paddingBottom: '16px', borderBottom: '2px solid #FFDD09' },
        formGroup: { marginBottom: '20px' },
        label: { display: 'block', fontWeight: '500', marginBottom: '8px', color: '#C9262C', fontSize: '13px' },
        requiredStar: { color: '#C9262C', marginLeft: '4px', fontSize: '14px' },
        inputWrapper: { display: 'flex', gap: '12px' },
        input: { width: '100%', borderRadius: '12px', border: '2px solid #e5e7eb', padding: '10px 16px', fontSize: '14px', transition: 'all 0.3s', outline: 'none', background: '#f9fafb' },
        inputError: { borderColor: '#C9262C', background: '#fff5f5' },
        errorMessage: { color: '#C9262C', fontSize: '12px', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' },
        row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
        button: { borderRadius: '12px', height: '42px', padding: '0 24px', fontWeight: '600', border: 'none', cursor: 'pointer', fontSize: '14px', transition: 'all 0.3s' },
        buttonPrimary: { background: '#C9262C', color: 'white' },
        buttonSuccess: { background: '#FFDD09', color: '#C9262C' },
        verifiedBadge: { background: '#FFF9E6', border: '1px solid #FFDD09', borderRadius: '12px', padding: '12px', textAlign: 'center', color: '#C9262C', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '14px', fontWeight: '500' },
        processingBadge: { background: '#E6F7FF', border: '1px solid #1890ff', borderRadius: '12px', padding: '12px', textAlign: 'center', color: '#1890ff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '14px', fontWeight: '500' }
    };

    return (
        <div style={styles.pageWrapper}>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.leftPanel}>
                        <div style={styles.welcomeTitle}>Create Employee</div>
                        <div style={styles.welcomeText}>Add new team members with secure verification</div>
                        <div>
                            <div style={styles.feature}>
                                <div style={styles.featureIcon}><CheckCircleOutlined /></div>
                                <div style={{ fontSize: '13px' }}><strong>Secure Verification</strong><br />PAN via DigiLocker</div>
                            </div>
                            <div style={styles.feature}>
                                <div style={styles.featureIcon}><UserOutlined /></div>
                                <div style={{ fontSize: '13px' }}><strong>Quick Process</strong><br />Easy onboarding</div>
                            </div>
                        </div>
                    </div>

                    <div style={styles.rightPanel}>
                        <div style={styles.formTitle}>Employee Details</div>
                        <div style={styles.formSubtitle}>Fill the information below</div>

                        <div style={styles.row}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>First Name <span style={styles.requiredStar}>*</span></label>
                                <input type="text" name="firstName" placeholder="Enter first name" onChange={onChangeValue} onBlur={(e) => handleBlur('firstName', e.target.value)} value={isData.firstName || ''} style={{ ...styles.input, ...(touched.firstName && errors.firstName ? styles.inputError : {}) }} readOnly={isMobileNumberVerify} />
                                {touched.firstName && errors.firstName && <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.firstName}</div>}
                            </div>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Last Name <span style={styles.requiredStar}>*</span></label>
                                <input type="text" name="lastName" placeholder="Enter last name" onChange={onChangeValue} onBlur={(e) => handleBlur('lastName', e.target.value)} value={isData.lastName || ''} style={{ ...styles.input, ...(touched.lastName && errors.lastName ? styles.inputError : {}) }} readOnly={isMobileNumberVerify} />
                                {touched.lastName && errors.lastName && <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.lastName}</div>}
                            </div>
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>PAN Card Number <span style={styles.requiredStar}>*</span></label>
                            <input type="text" name="pancardNumber" placeholder="ABCDE1234F" onChange={onChangeValue} onBlur={(e) => handleBlur('pancardNumber', e.target.value)} maxLength={10} value={isData.pancardNumber || ''} style={{ ...styles.input, ...(touched.pancardNumber && errors.pancardNumber ? styles.inputError : {}) }} readOnly={isMobileNumberVerify || isPanNumberVerify} />
                            {touched.pancardNumber && errors.pancardNumber && <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.pancardNumber}</div>}
                        </div>

                        <div style={styles.formGroup}>
                            <label style={styles.label}>Mobile Number <span style={styles.requiredStar}>*</span></label>
                            <div style={styles.inputWrapper}>
                                <input type="text" name="mobileNumber" placeholder="10-digit mobile number" onChange={onChangeValue} onBlur={(e) => handleBlur('mobileNumber', e.target.value)} maxLength={10} onKeyDown={isNumber} value={isData.mobileNumber || ''} style={{ ...styles.input, ...(touched.mobileNumber && errors.mobileNumber ? styles.inputError : {}) }} readOnly={isOtpNumber || isMobileNumberVerify} />
                                {!isMobileNumberVerify && !isOtpNumber && <Button onClick={handleVerifyMobileNumber} loading={isLoading} style={{ ...styles.button, ...styles.buttonPrimary }}>Send OTP</Button>}
                            </div>
                            {touched.mobileNumber && errors.mobileNumber && <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.mobileNumber}</div>}
                        </div>

                        {isOtpNumber && !isMobileNumberVerify && (
                            <div style={styles.formGroup}>
                                <label style={styles.label}>OTP Number <span style={styles.requiredStar}>*</span></label>
                                <div style={styles.inputWrapper}>
                                    <input type="text" name="OtpNumber" placeholder="Enter 4-digit OTP" onChange={onChangeValue} onBlur={(e) => handleBlur('OtpNumber', e.target.value)} maxLength={4} onKeyDown={isNumber} value={isData.OtpNumber || ''} style={{ ...styles.input, ...(touched.OtpNumber && errors.OtpNumber ? styles.inputError : {}) }} />
                                    <Button onClick={handleVerifyOtpMobileNumber} loading={isLoading} style={{ ...styles.button, ...styles.buttonSuccess }}>Verify OTP</Button>
                                </div>
                                {touched.OtpNumber && errors.OtpNumber && <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.OtpNumber}</div>}
                            </div>
                        )}

                        {isMobileNumberVerify && !isPanNumberVerify && isLoading && (
                            <div style={styles.processingBadge}><RiseLoader color="#1890ff" loading={true} size={8} /> Verifying PAN via DigiLocker...</div>
                        )}

                        {isMobileNumberVerify && isPanNumberVerify && (
                            <div style={styles.verifiedBadge}><CheckCircleOutlined /> PAN verified successfully! Creating account...</div>
                        )}
                    </div>
                </div>

                <Modal open={showingSubmitPopup} footer={null} onCancel={handleCancelPopup} centered width={440}>
                    <div style={{ textAlign: 'center', padding: '32px 24px' }}>
                        <div style={{ width: '64px', height: '64px', background: '#C9262C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                            <CheckCircleOutlined style={{ fontSize: '32px', color: '#FFDD09' }} />
                        </div>
                        <h3 style={{ fontSize: '20px', marginBottom: '8px', color: '#C9262C' }}>Registration Successful!</h3>
                        <p style={{ color: '#6b7280', marginBottom: '20px' }}>Employee account created</p>
                        <div style={{ background: '#f3f4f6', padding: '16px', borderRadius: '12px', marginBottom: '20px', textAlign: 'left' }}>
                            <p style={{ marginBottom: '8px' }}><strong>Username:</strong> {username}</p>
                            <p style={{ marginBottom: 0 }}><strong>Password:</strong> {password}</p>
                        </div>
                        <Button onClick={handleCancelPopup} block style={{ borderRadius: '10px', height: '42px', background: '#C9262C', color: 'white', border: 'none' }}>Continue</Button>
                    </div>
                </Modal>
                
                <ToastContainer position="top-right" autoClose={5000} />
            </div>
        </div>
    );
}

export default CreateStaff;